export default async ({ store }) => {
  store.dispatch('user/initializeUser');
  store.dispatch('location/fetchDeliveryMethods');
  store.dispatch('payment/fetchAllPaymentMethods');
  store.dispatch('location/fetchLocations');
  await store.dispatch('category/fetchCategories');
};
